import axios from 'axios'
import API from '@/common/api'
import moment from 'moment-timezone'
import regExp from '../../common/regExp'
import store from '..'

export default {
  namespaced: true,
  state: {
    page: {},
    setModuleReady: [],
    pageState: null,
    hasPrice: false,
    disabledTax: false,
    priceOption: [], // vuex의 object.values 버그인지 computing을 못해서 배열로 처리
    priceInfo: {},
    pageType: null, // dgb, ...
    usableCoupon: null
  },
  mutations: {
    pageInit (state) {
      state.page = {}
      state.setModuleReady = []
      state.pageState = null
      state.hasPrice = false
    },
    setPageType (state, data) {
      state.pageType = data
    },
    hasPrice (state, data) {
      state.hasPrice = data
    },
    priceInit (state) {
      state.hasPrice = false
      state.priceOption = []
      state.priceInfo = {}
    },
    priceOption (state, data) {
      const prices = state.priceOption
      let pricesItem = state.priceOption.find(x => x.id === data.id)
      const isCheckbox = data.id.indexOf('_') !== -1
      if (!pricesItem) {
        if (data.price || (isCheckbox && data.toggle === 'add')) {
          delete data.toggle
          state.priceOption = state.priceOption.concat([data])
        }
      } else {
        if (!data.price || (isCheckbox && data.toggle === 'remove')) {
          state.priceOption = state.priceOption.filter(x => x.id !== data.id)
        }
      }
      const dataId = isCheckbox ? data.optId : data.id
      state.priceOption = state.priceOption.map(x => {
        const id = x.id.indexOf('_') !== -1 ? x.optId : x.id
        const isItem = x.id === data.id
        return {
          ...x,
          ...(x.isSub && (data.subOptionList && data.subOptionValue) && x.parentOption === dataId) && {
            hide: isCheckbox
              ? data.subOptionList.includes(id) && !data.subOptionValue.includes(id)
              : data.subOptionList.includes(id) && data.subOptionValue !== id
          },
          ...data.subOptionList && isItem && {
            subOptionList: data.subOptionList,
            subOptionValue: data.subOptionValue
          },
          ...isItem && {
            price: data.price,
            label: data.label,
            quantity: data.quantity
          }
        }
      })
    },
    updateOption (state, data) {
      const option = state.priceOption.find(x => x.id === data.id)
      if (option) {
        option.quantity = data.quantity
      }
    },
    priceInfo (state, data) {
      state.priceInfo = { ...state.priceInfo, ...data }
    },
    addModule (state, data) {
      const insert = (arr, index, item) => [
        ...arr.slice(0, index),
        item,
        ...arr.slice(index)
      ]
      state.page.module = insert(state.page.module, data.index, data.item)
    },
    disabledTax (state, data) {
      state.disabledTax = data
    },
    setPageState (state, data) {
      state.pageState[data.target] = data.value
    },
    usableCoupon (state, data) {
      state.usableCoupon = data
    },
    responsiveModule (state, responsive) {
      if (state.page.mobileModule && state.page.tabletModule) {
        if (responsive === 'mobile') {
          state.page.module = state.page.mobileModule
        } else if (responsive === 'tablet') {
          state.page.module = state.page.tabletModule
        }
      }
    },
    readyModule (state, moduleId) {
      state.setModuleReady = state.setModuleReady.filter(x => x !== moduleId).concat(moduleId)
    }
  },
  actions: {
    async getAllPage () {
      const siteId = store.state.authentication.site
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=sc-page-manage&func=get-all-page-id&id=a.${siteId}`)
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async loadProduct ({ dispatch, state }, id) {
      const file = `product/item/${id}.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async loadPage ({ dispatch, commit, state }, id, onlyLoad) {
      const siteId = id.split('.')[0]
      // const siteId = API.SITE_INFO.site
      const file = `page/item/${id}.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${siteId}&file=${file}`)
        if (onlyLoad) return res.data.message
        dispatch('setPage', { id: id, data: res.data.message })
        return res.data.message
      } catch (ex) {
        return ex
      }
    },
    setPage ({ dispatch, state, commit, rootState }, data) {
      const getProductAvailableTime = store.getters['product/getProductAvailableTime']
      const responsive = window.innerWidth >= 768 ? 'tablet' : 'mobile'
      const lang = rootState.common.lang.default
      function getSubOption (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (item.item) {
            for (let j = 0; j < item.item.length; j++) {
              const opt = item.item[j]
              if (opt.subOption && opt.subOption !== '') {
                result.push({
                  parent: item.id,
                  parentLabel: item.label,
                  parentValue: opt.value,
                  child: opt.subOption
                })
              }
            }
          }
        }
        return result
      }
      function setActionModules (data) {
        if (data.module) {
          const name = /input|radio|checkbox|select/
          const subModules = data.module.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.module.filter(x => x.type === 'action' && x.setting.action && x.setting.action.name === 'input').map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          })
          data.subOption = subOption
          data.module.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
          /**
           * 페이지에 상품불러오기 설정 되어 있는 경우
           * 상품가격, min/max 상품정보로 맵핑
          */
          if (data.product_link && data.product_list && data.product_item) {
            dispatch('loadProduct', data.product_list).then((list) => {
              const product = list && list.items ? list.items.find(x => x.id === data.product_item) : null
              data.module.forEach(function (module) {
                if (module.type === 'action' && module.setting.action) {
                  if (product && data.product_link && data.product_list && data.product_item) {
                    if (module.name === 'quantity') {
                      const submitData = rootState.submit.submitData.find(x => x.name === 'quantity')
                      module.setting.action.price.isPrice = true
                      module.setting.action.price.value = product.info.price
                      module.setting.action.min = product.info.min
                      module.setting.action.max = product.info.max
                      if (submitData) {
                        submitData.value.price = product.info.price
                        submitData.value.value = product.info.min
                      }
                    }
                  }
                }
              })
              if (product && product.pickup) {
                data.pickup = product.pickup
                if (product.pickup === 'auto') {
                  data.pickupTime = product.pickupTime
                }
              }
              return true
            })
          }
        }
        if (data.mobileModule) {
          const name = /input|radio|checkbox|select/
          const subModules = data.mobileModule.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.mobileModule.filter(x => x.type === 'action' && x.setting.action && x.setting.action.name === 'input').map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          })
          data.subOption = subOption
          data.mobileModule.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
          /**
           * 페이지에 상품불러오기 설정 되어 있는 경우
           * 상품가격, min/max 상품정보로 맵핑
          */
          if (data.product_link && data.product_list && data.product_item) {
            dispatch('loadProduct', data.product_list).then((list) => {
              const product = list && list.items ? list.items.find(x => x.id === data.product_item) : null
              data.mobileModule.forEach(function (module) {
                if (module.type === 'action' && module.setting.action) {
                  if (product && data.product_link && data.product_list && data.product_item) {
                    if (module.name === 'quantity') {
                      const submitData = rootState.submit.submitData.find(x => x.name === 'quantity')
                      module.setting.action.price.isPrice = true
                      module.setting.action.price.value = product.info.price
                      module.setting.action.min = product.info.min
                      module.setting.action.max = product.info.max
                      if (submitData) {
                        submitData.value.price = product.info.price
                        submitData.value.value = product.info.min
                      }
                    }
                  }
                }
              })
              if (product && product.pickup) {
                data.pickup = product.pickup
                if (product.pickup === 'auto') {
                  data.pickupTime = product.pickupTime
                }
              }
              return true
            })
          }
        }
        if (data.tabletModule) {
          const name = /input|radio|checkbox|select/
          const subModules = data.tabletModule.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.tabletModule.filter(x => x.type === 'action' && x.setting.action && x.setting.action.name === 'input').map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          })
          data.subOption = subOption
          data.tabletModule.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
          /**
           * 페이지에 상품불러오기 설정 되어 있는 경우
           * 상품가격, min/max 상품정보로 맵핑
          */
          if (data.product_link && data.product_list && data.product_item) {
            dispatch('loadProduct', data.product_list).then((list) => {
              const product = list && list.items ? list.items.find(x => x.id === data.product_item) : null
              data.tabletModule.forEach(function (module) {
                if (module.type === 'action' && module.setting.action) {
                  if (product && data.product_link && data.product_list && data.product_item) {
                    if (module.name === 'quantity') {
                      const submitData = rootState.submit.submitData.find(x => x.name === 'quantity')
                      module.setting.action.price.isPrice = true
                      module.setting.action.price.value = product.info.price
                      module.setting.action.min = product.info.min
                      module.setting.action.max = product.info.max
                      if (submitData) {
                        submitData.value.price = product.info.price
                        submitData.value.value = product.info.min
                      }
                    }
                  }
                }
              })
              if (product && product.pickup) {
                data.pickup = product.pickup
                if (product.pickup === 'auto') {
                  data.pickupTime = product.pickupTime
                }
              }
              return true
            })
          }
        }
        return data
      }
      if (data && data.data) {
        const isVisible = data.data.state === '01' // 페이지 자체 공개여부
        let available = getProductAvailableTime || data.data.available // submit 데이터
        const isAlways = available.state === '01' // 01 ? always : each
        const today = moment().isoWeekday() - 1
        const day = available.set[today]
        const getAvailableDay = store.getters['util/getAvailableDay']
        const check = getAvailableDay(day)
        const isAvailable = isAlways
          ? true
          : check
        state.page = setActionModules(data.data)
        state.page.id = data.id
        state.page.available = {
          ...state.page.available,
          set: state.page.available.set.map(x => {
            const time = x.time || (x.timeFrom && x.timeTo && {
              time: [
                {
                  from: x.timeFrom,
                  to: x.timeTo
                }
              ]
            })
            return {
              ...x,
              ...time
            }
          })
        }
        state.pageState = {
          visible: isVisible,
          available: isAvailable
        }
        commit('responsiveModule', responsive)
      }
      return true
    }
  },
  getters: {
    getPage: state => {
      const getProductAvailableTime = store.getters['product/getProductAvailableTime']
      return {
        ...state.page,
        ...getProductAvailableTime && { // 상품에서 연결된 상품의 경우 상품의 이용가능시간을 적용한다
          available: getProductAvailableTime
        }
      }
    },
    getPageState: state => state.pageState,
    getPrice: state => price => {
      return Number(price) !== 0 ? `(${price})` : ''
    },
    getPriceOption: state => {
      return state.priceOption.filter(x => !x.hide)
    },
    getPriceInfo: state => state.priceInfo,
    getPageType: state => state.pageType,
    getUsableCoupon: state => state.usableCoupon,
    getIsPageReady: state => {
      /**
       * 현재 활성화(mobileModule || tabletModule) 모듈의 ids
       * 전처리 완료된 모듈의 ids (Module.vue에서 처리될때마다 보냄)
       */
      const ids = state.page.module.map(x => x.id) // 현재 모듈 ids
      const allIds = state.setModuleReady // 전처리 완료된 모듈 ids
      return ids.filter(x => !allIds.includes(x)).length === 0
    }
  }
}
